import {
    Grid
} from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseTable from "../../table/BaseTable";
import BasicDialog from "../../../components/base/BasicDialog/BasicDialog";

export default function LegendDialog({ open, onClose, tableData, dialogTitle}) {
    const { t } = useTranslation();
    
    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={dialogTitle || t("legend")}
            maxWidth="sm"
            titleSx={{textAlign: "center"}}
            showBottomCloseButton={false}
            showDialogActions={false}
        >
            <Grid container>
                <Grid item xs={12}>
                    {tableData && <BaseTable
                        stickyHeader={false}
                        headers={tableData.headers}
                        rows={tableData.rows}
                        showEditButton={false}
                        showDeleteButton={false}
                        sortable={false}
                        hiddenColumns={[]}
                        selectedRows={[]}
                        colMaxLength={1024}  
                    />}
                </Grid>
            </Grid>
        </BasicDialog>
    );
}